import * as React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { cn } from '@/lib/utils';

export interface SectionCardProps {
  /** 區塊標題 */
  title: string;
  /** 區塊內容 */
  children: React.ReactNode;
  /** 選填：標題列右側動作（例如編輯按鈕） */
  action?: React.ReactNode;
  /** 選填：覆寫外層樣式 */
  className?: string;
}

/**
 * 共用區塊卡片：標題 + 白底卡片，用於會員區等一致樣式。
 * 使用既有 Card / CardHeader / CardTitle / CardContent，樣式與會員區一致。
 */
export function SectionCard({
  title,
  children,
  action,
  className,
}: SectionCardProps) {
  return (
    <Card
      className={cn(
        'rounded-lg shadow-sm border border-gray-200 bg-white mb-4',
        className
      )}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 p-6 pb-4">
        <CardTitle className="text-xl font-semibold text-gray-900">
          {title}
        </CardTitle>
        {action}
      </CardHeader>
      <CardContent className="p-6 pt-0">{children}</CardContent>
    </Card>
  );
}
